import { appendIf } from '@btime/helpers'
import { gql, useMutation } from '@apollo/client'
import { useTranslation } from 'react-i18next'
import { useSessionPermission } from '@btime/react-session'

import { cleanRequest } from './cleanRequest'
import { generalClient } from '../../../../utils/apollo/api'
import { useModalData, useModalsActions } from '../../../../components/modals/ModalsContext'

const MUTATION = gql`
  mutation UpsertLinkTree($input: LinkTreeInput) {
    upsertLinkTree(input: $input) {
      id
    }
  }
`

const useValidate = () => {
  const { t } = useTranslation(['validations', 'editLinkTree'])
  const data = useModalData()
  const canConfigureAssetQrCodeMenuRules = useSessionPermission('configureAssetQrCodeMenuRules')
  const requiresAssetTypes = data?.data?.entity === 'assets' && canConfigureAssetQrCodeMenuRules

  return (form, setErrors) => {
    const errors = [
      ...appendIf(!form.name, { path: ['name'], message: t('validations:required') }),
      ...appendIf(requiresAssetTypes && !form.assetTypeIds?.length, {
        path: ['assetTypeIds'],
        message: t('editLinkTree:assetTypesRequired')
      })
    ]

    setErrors(errors)
    return errors.length === 0
  }
}

export const useSaveLinkTreeMenu = () => {
  const { onGoBack } = useModalsActions()
  const [request, state] = useMutation(MUTATION, { refetchQueries: ['LinkTree'], client: generalClient })
  const data = useModalData()
  const validate = useValidate()

  const handleRequest = (form, actions) => {
    const { setErrors } = actions
    const isValid = validate(form, setErrors)

    if (isValid) {
      const input = cleanRequest(form, data)
      return request({ variables: { input } }).then(resp => {
        if (!resp.errors) {
          onGoBack()
        }
      })
    }
  }

  return [handleRequest, state]
}
